<template>
  <div>
    <!-- Page header -->
    <CCard class="mb-4">
      <CCardBody class="p-4">
        <CRow class="align-items-center">
          <CCol md="8">
            <h1 class="h4 mb-1">Branding</h1>
            <p class="text-muted mb-0">
              Your custom domain, logo and browser icon
            </p>
          </CCol>
          <CCol md="4" class="d-flex justify-content-md-end mt-3 mt-md-0">
            <CButton color="primary" :disabled="loading || error" @click="onEdit">
              <CIcon name="cil-pencil" /> Edit branding
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <div v-if="loading" class="text-center p-5">
          <CSpinner color="primary" />
        </div>
        <div v-else-if="error" class="text-center p-5">
          <CIcon name="cil-warning" size="xl" class="text-danger mb-2" />
          <h2 class="h6">Couldn't load your branding</h2>
          <p class="text-muted">Check your connection and try again.</p>
          <CButton color="primary" variant="outline" @click="resetObj">
            <CIcon name="cil-reload" /> Retry
          </CButton>
        </div>
        <template v-else>
          <CRow>
            <CCol md="6" class="mb-4">
              <div class="small text-muted">Custom domain</div>
              <div>{{ (obj.tenant && obj.tenant.domainName) || "Not set" }}</div>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="6" class="mb-3">
              <div class="small text-muted mb-1">Logo</div>
              <CImg :src="getLogoUrl()" alt="Business logo" thumbnail responsive />
            </CCol>
            <CCol md="6" class="mb-3">
              <div class="small text-muted mb-1">Browser icon (favicon)</div>
              <CImg :src="getFavIconUrl()" alt="Browser icon" thumbnail responsive />
            </CCol>
          </CRow>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import BrandingApi from "../../lib/brandingApi";

export default {
  name: "Company",
  data() {
    return {
      loading: true,
      error: false,
      api: new BrandingApi(),
      obj: {
        logoUrl: "",
      },
    };
  },
  mounted() {
    this.resetObj();
  },
  methods: {
    getFavIconUrl() {
      return this.removeTrailingSlash(apiUrl) + this.obj.faviconUrl;
    },
    getLogoUrl() {
      return this.removeTrailingSlash(apiUrl) + this.obj.logoUrl;
    },
    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    onEdit() {
      this.$router.push({
        path: `/tenants/brandingEdit`,
      });
    },
    resetObj() {
      var self = this;
      self.loading = true;
      self.error = false;
      this.api
        .getByCurrentUser()
        .then((response) => {
          self.obj = response.result || {};
        })
        .catch((err) => {
          console.error(err);
          self.error = true;
        })
        .finally(() => {
          self.loading = false;
        });
    },
  },
};
</script>
